// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isDeliverabilityPostmasterAppGroupIdIpReputationResult = objectOf({
  date: string,
  domain: string,
  reputation: string,
  sample_ip: string,
});
